export default __webpack_public_path__ + "static/media/scan.f81a88fd.png";